module.exports = __webpack_public_path__ + "static/media/cover-unavaliable-purple.352f6388.png";